import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomeBannerContent2 = () => {
    let navigate = useNavigate();
    return (
        <div className='HomeBannerContent1'>
            <div className="banner-form-wrapper form_two">
                <div className="banner-form-content-wrapper wow animate__animated animate__fadeInDown">
                    {/* <h2>Fill your Information</h2> */}
                    <h5> <span className='Fill_In_Your_Information'>Fill In Your Information</span>   <br/> For A Free Cone On Your Next On Demand Order</h5>
                </div>
                <form >
                    <div className="form-group">
                        <input type="text" placeholder="NAME" className="form-control" />
                    </div>
                    <div className="form-group">
                        <input type="email" placeholder="EMAIL" className="form-control" />
                    </div>
                    <div className="form-group">
                        <input type="tel" placeholder="NUMBER" className="form-control" />
                    </div>
                    <div className="form-group">
                        <input type="text" placeholder="ADDRESS" className="form-control" />
                    </div>
                    <div className="form-group">
                        <button
                            onClick={() => { navigate('/congrats') }}
                            type="submit" className="btn form-control py-0">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default HomeBannerContent2;